<template>
  <el-form label-width="80px" :model="formmodel">
    <el-form-item label="客服类型：">
        <el-radio-group v-model="formmodel.type" @change="changeFunc">
            <el-radio :label="'chat'">在线聊天(小程序)</el-radio>
            <el-radio :label="'phone'">拨打电话</el-radio>
        </el-radio-group>
    </el-form-item>
    <el-form-item label="电话号码：" v-show="formmodel.type == 'phone'">
        <el-input v-model="formmodel.phone_num" @input="changeFunc"></el-input>
    </el-form-item>

  </el-form>
</template>

<script>
  export default{
    data(){
      return {
        /*form模型*/
        formmodel: {
            type:'type',
            phone_num:''
        }
      }
    },
    methods:{
      /*选中的值*/
      changeFunc(e){
        //从e中把name和ur赋值到下面的对象
        let boj = this.formmodel;
        boj.linktype = 'service';
        boj.url = this.formmodel.type;
        if(this.formmodel.type == 'phone'){
            boj.phone_num = this.formmodel.phone_num;
        }
        boj.name = this.formmodel.type == 'chat'?'在线聊天':'拨打电话';
        this.$emit('changeData',boj);
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/setlink/part/Service.vue